import { animatedLogosInit } from "../animatedlogos";
import { initSideGrid } from "../grid/sidegrid";

export function jobListingItem($block, isadmin) {

  // var $ = $ || jQuery; // added to see solve jquery issue

  console.log("jobListingItem", $block, isadmin);

  if (isadmin == true) {
    console.log("admin == true:", isadmin);
  } else {
    console.log("admin == false:", isadmin);
  };


  var container = $block[0];
  var gridLocation = container.querySelector(".side-grid-container"); //reviews
  var animatedLogoType = container;//.querySelector(".animated-logo");

  console.log("jobListing ITEM container", container);
    initSideGrid(gridLocation, false, false, false, false, false);
    animatedLogosInit(animatedLogoType, "job-listing-item");
  // animatedLogosInit(container, "job-listing-item"); 
  
} //export function jobListing(block)